export default __webpack_public_path__ + "static/media/banner-presenting-present.593de996.png";